<script>
import { mapGetters } from 'vuex'
import { EmailConfirmedStatus } from '@/enums/EmailConfirmedStatus.js'
import changeEmailConfirmationJson from '@/data/json/views/changeEmailConfirmation.json'

export default {
  data: vm => ({
    content: changeEmailConfirmationJson.data,
    dialog: true,
    token: encodeURIComponent(vm.$route.params.token),
    newEmail: vm.$route.params.userEmail,
    newEmailEncoded: encodeURIComponent(vm.$route.params.userEmail),
    userId: vm.$route.params.userId,
    loading: true,
    status: null,
    emailConfirmedStatus: EmailConfirmedStatus
  }),
  computed: {
    ...mapGetters(['locale']),
    contentText() {
      return contentKey =>
        this.$cmsService.getContent(
          this.content,
          contentKey + this.contentKeyExtension
        )
    },
    contentKeyExtension() {
      return this.status
        ? '_' + EmailConfirmedStatus.getKey(this.status).toLowerCase()
        : ''
    }
  },
  created() {
      this.$userService.confirmEmailChange({
        token: this.token,
        newEmail: this.newEmailEncoded,
        userId: this.userId
      })
        .then(response => {
           const statusKey = EmailConfirmedStatus.getKey(response);
           this.status = statusKey ? EmailConfirmedStatus[statusKey] : EmailConfirmedStatus.Error;
        })
        .catch(error => {
          const errorStatus = error.response?.status || error.status;
          if (errorStatus) {
            const statusKey = EmailConfirmedStatus.getKey(errorStatus);
            this.status = statusKey ? EmailConfirmedStatus[statusKey] : EmailConfirmedStatus.Error;
          } else {
            this.status = EmailConfirmedStatus.Error;
          }
        })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    closeDialog() {
      this.dialog = false
      this.$router.push({ name: 'login', params: { locale: this.locale } })
    }
  }
}
</script>
<template>
  <v-dialog v-model="dialog" max-width="500" persistent>
    <v-card>
      <DialogBaseColoredTitle>
        {{ $cms.get(content, 'header') }}
      </DialogBaseColoredTitle>
      <DialogBaseCloseIcon color="white" @click="closeDialog" />
      <v-divider></v-divider>
      <DialogBaseText class="text-center">
        <v-progress-circular
          v-if="loading"
          indeterminate
          color="primary"
          class="mr-2"
        ></v-progress-circular>
        <v-row>
          <v-col><span v-html="contentText('content')"></span></v-col>
        </v-row>
        <v-divider></v-divider>
      </DialogBaseText>
      <DialogBaseActions>
        <v-btn
          v-if="!loading"
          color="primary"
          class="white--text text-capitalize px-8 py-2"
          @click="closeDialog"
        ><span>{{ $cms.get(content, 'button') }}</span></v-btn
        >
      </DialogBaseActions>
    </v-card>
  </v-dialog>
</template>
<style lang="scss" scoped>
.close-icon {
  position: absolute;
  top: 0;
  right: 0;
}
</style>
